// Ключ «текущей сессии» раздела (перенос utils/sessionUtils.ts исходника)
const BROWSER_SESSION_KEY = 'sz_currentSessionKey'
export const SESSION_MODE_STORAGE_KEY = 'sessionClearMode'

const randomKey = () => {
    if (typeof crypto !== 'undefined' && crypto.randomUUID) return crypto.randomUUID()
    return Math.random().toString(36).slice(2) + Math.random().toString(36).slice(2)
}

const partsMap = (date, timeZone, withTime = false) => {
    const opts = { timeZone, year: 'numeric', month: '2-digit', day: '2-digit' }
    if (withTime) Object.assign(opts, { hour: '2-digit', minute: '2-digit', second: '2-digit', hour12: false })
    const map = {}
    for (const p of new Intl.DateTimeFormat('en-CA', opts).formatToParts(date)) {
        if (p.type !== 'literal') map[p.type] = p.value
    }
    return map
}

// Дата YYYY-MM-DD по Москве
export const getMoscowDateKey = (date = new Date()) => {
    const map = partsMap(date, 'Europe/Moscow')
    return `${map.year}-${map.month}-${map.day}`
}

const getTimeZoneOffsetMs = (date, timeZone) => {
    const map = partsMap(date, timeZone, true)
    const asUtcMs = Date.UTC(
        Number(map.year), Number(map.month) - 1, Number(map.day),
        Number(map.hour) % 24, Number(map.minute), Number(map.second), 0,
    )
    return asUtcMs - date.getTime()
}

// Ближайшая полночь по Москве (мс от эпохи)
export const getNextMoscowMidnightMs = (now = new Date()) => {
    const map = partsMap(now, 'Europe/Moscow')
    const guessUtcMs = Date.UTC(Number(map.year), Number(map.month) - 1, Number(map.day) + 1, 0, 0, 0, 0)
    const offsetMs = getTimeZoneOffsetMs(new Date(guessUtcMs), 'Europe/Moscow')
    return guessUtcMs - offsetMs
}

// Ключи хранилищ с id пользователя: у каждого пользователя inside свой режим и своя сессия вкладки
const userKey = (base, userId) => (userId ? `${base}:${userId}` : base)

// 'daily' -> daily:YYYY-MM-DD; 'onClose' -> browser:<uuid> (живёт, пока открыта вкладка)
export const getSessionKey = (mode, moscowDayKey, userId) => {
    if (mode === 'daily') return `daily:${moscowDayKey || getMoscowDateKey()}`
    const storageKey = userKey(BROWSER_SESSION_KEY, userId)
    let existing = null
    try { existing = sessionStorage.getItem(storageKey) } catch (e) { /* приватный режим */ }
    if (existing) return existing
    const next = `browser:${randomKey()}`
    try { sessionStorage.setItem(storageKey, next) } catch (e) { /* приватный режим */ }
    return next
}

// Старый общий ключ — фолбэк, если у пользователя ещё нет своего
export const loadSessionClearMode = (userId) => {
    try {
        let value = userId ? localStorage.getItem(userKey(SESSION_MODE_STORAGE_KEY, userId)) : null
        if (value === null) value = localStorage.getItem(SESSION_MODE_STORAGE_KEY)
        return value === 'daily' ? 'daily' : 'onClose'
    } catch (e) {
        return 'onClose'
    }
}

export const saveSessionClearMode = (mode, userId) => {
    try { localStorage.setItem(userKey(SESSION_MODE_STORAGE_KEY, userId), mode) } catch (e) { /* приватный режим */ }
}
